var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticStyle: { margin: "10px 0 10px 10px" } }, [
          _c(
            "div",
            [
              !_vm.isEdit
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: [
                            "button_AviationExchange_aviationExchangeConfig"
                          ],
                          expression:
                            "['button_AviationExchange_aviationExchangeConfig']"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EditTo")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toCancel } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toSave } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("span", { staticStyle: { margin: "0 5px 0 10px" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SetBranch")))
              ]),
              _c(
                "el-select",
                {
                  attrs: { filterable: "" },
                  on: { change: _vm.changeBranchId },
                  model: {
                    value: _vm.form.branchId,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "branchId", $$v)
                    },
                    expression: "form.branchId"
                  }
                },
                _vm._l(_vm.officeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: _vm.getOfficeLabel(item),
                      value: item.officeId
                    }
                  })
                }),
                1
              ),
              _vm.form.branchId !== 1
                ? _c(
                    "span",
                    [
                      _c("el-checkbox", {
                        staticStyle: { margin: "0 5px 0 15px" },
                        attrs: {
                          value: _vm.form.useHqSet,
                          disabled: !_vm.isEdit
                        },
                        on: {
                          input: function($event) {
                            return _vm.onUseHqSetInput(!_vm.form.useHqSet)
                          }
                        }
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FollowHQ")))
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticClass: "tabs-container",
            staticStyle: { position: "relative" }
          },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%", "margin-left": "10px" },
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    key: 1,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_DeclarationScope"),
                      name: "tabDeclarationScope"
                    }
                  },
                  [
                    _c("tab-declaration-scope", {
                      ref: "tabDeclarationScope",
                      attrs: {
                        "is-edit": _vm.isEdit,
                        "use-hq-set": _vm.form.useHqSet,
                        "branch-id": _vm.form.branchId
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 2,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_AlertNotification"),
                      name: "tabAlarmNotification"
                    }
                  },
                  [
                    _c("tab-alarm-notification", {
                      ref: "tabAlarmNotification",
                      attrs: {
                        "is-edit": _vm.isEdit,
                        "use-hq-set": _vm.form.useHqSet,
                        "branch-id": _vm.form.branchId
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 3,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_RPASettings"),
                      name: "tabRpaSettings"
                    }
                  },
                  [
                    _c("tab-rpa-settings", {
                      ref: "tabRpaSettings",
                      attrs: {
                        "is-edit": _vm.isEdit,
                        "use-hq-set": _vm.form.useHqSet,
                        "branch-id": _vm.form.branchId
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }